import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../scss/Sidebar.css';


const Sidebar = () => {
  return (
    <div className='sidebar-menu'>
          <NavLink to="/landing" exact><h2 title='Classroom Bucket'><i class="fas fa-backpack"></i></h2></NavLink>
      <div className='Sidebar-nav'>
        <div className='sidebar-item'>
          <NavLink to="/" exact className="s-item" title='Home' activeClassName="active"> <i class="fas fa-home"></i>  </NavLink>
        </div>
        <div className='sidebar-item'>
          <NavLink to="/notes" exact className="s-item" title='Notes' activeClassName="active"> <i class="fas fa-books"></i> </NavLink>
        </div>
        <div className='sidebar-item'>
          <NavLink to="/tags" exact className="s-item" title='Tags' activeClassName="active"> <i class="far fa-tags"></i> </NavLink>
        </div>
        <div className='sidebar-item'>
          <NavLink to="/News" exact className="s-item" title='News' activeClassName="active"> <i class="far fa-newspaper"></i> </NavLink>
        </div>
        <div className='sidebar-item'>
          <NavLink to="/user" exact className="s-item" title='Users' activeClassName="active"> <i class="far fa-user"></i> </NavLink>
        </div>
        <div className='sidebar-item'>
          <NavLink to="/drive" exact className="s-item" title='Drive' activeClassName="active"> <i class="fab fa-google-drive"></i> </NavLink>
        </div>
        <div className='sidebar-item'>
          <NavLink to="/settings" exact className="s-item" title='Settings' activeClassName="active"> <i class="far fa-cog"></i> </NavLink>
        </div>

        <div className='sidebar-item'>
          <NavLink to="/form" exact className="s-item" title='Form' activeClassName="active"> <i class="fas fa-keyboard"></i> </NavLink>
        </div>
        <div className='sidebar-item-bottom'>
            <NavLink to="/logout" exact className="s-item" title='Logout' activeClassName="active"> <i class="fal fa-sign-out"></i> </NavLink>
        </div>
      </div>
      
    </div>
  );
};

export default Sidebar;
